

































import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import utils from '@/services/utils';

@Component
export default class RoundModalTracking extends Vue {
  @Prop() readonly trackingList!: any;

  @Prop() readonly modalType!: any;

  @Prop() readonly modalState!: any;

  utilsInstance = utils;

  nameType = ''

  created() {
    this.nameType = this.modalType.split('_');
    this.nameType = this.nameType[0].toLowerCase();
  }

  checkItemDetail(key) {
    return this.trackingList[key]
      ? this.trackingList[key]
      : '-';
  }

  checkRoundData(key) {
    return this.trackingList[0].roundData[this.nameType][0][key]
      ? this.trackingList[0].roundData[this.nameType][0][key]
      : '-';
  }

  checkBalance(key) {
    return this.trackingList[0].roundData[this.nameType][0].balance[key]
      ? this.trackingList[0].roundData[this.nameType][0].balance[key]
      : '-';
  }
}
